import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=51c3b0ab&scoped=true"
import script from "./OAuthLogin.vue?vue&type=script&lang=js"
export * from "./OAuthLogin.vue?vue&type=script&lang=js"
import style0 from "./OAuthLogin.vue?vue&type=style&index=0&id=51c3b0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3b0ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VStepper,VStepperContent,VStepperItems})
